var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-btn"},[_c('div',{staticClass:"copy"},[_vm._v(_vm._s(_vm.copy))]),_c('div',{staticClass:"arrow"},[_c('arrow-gray')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }